import paradas from "./paradas";
import rutas from "./rutas";
import turnos from "./turnos";

export default {
  paradas,
  rutas,
  turnos,
};
